import { container } from "tsyringe";

import type { INotificationDTO } from "coreframetypings/dto";

export interface IKeepAliveHandler {
    disableAutoLogout: boolean;

    notifySystemLock(notification: INotificationDTO): void;

    notifyNoSystemLock(): void;

    startWatchDog(): void;

    stopWatchDog(): void;
}

export default class KeepAliveHandler {
    public static getInstance(): IKeepAliveHandler {
        return container.resolve<IKeepAliveHandler>("KeepAliveHandler");
    }
}